import { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { NAV_LINKS } from "../data/mockData";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass-nav" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a
          href="#hero"
          data-testid="navbar-logo"
          className="group flex items-center gap-3"
          onClick={close}
        >
          <span className="grid h-9 w-9 place-items-center border border-brand bg-brand/10">
            <span className="block h-3 w-3 bg-brand" />
          </span>
          <span className="font-heading text-xl uppercase tracking-tight text-white">
            Taastrup <span className="text-brand">FC</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.replace("#", "")}`}
              className="mono-label text-neutral-300 transition-colors hover:text-brand"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#kontakt"
          data-testid="navbar-cta-contact"
          className="btn-primary hidden lg:inline-flex"
        >
          Kontakt
        </a>

        <button
          type="button"
          aria-label="Åbn menu"
          data-testid="navbar-mobile-toggle"
          className="inline-flex h-10 w-10 items-center justify-center border border-neutral-700 lg:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} weight="bold" /> : <List size={20} weight="bold" />}
        </button>
      </div>

      {open && (
        <div
          className="glass-nav border-t border-white/10 lg:hidden"
          data-testid="navbar-mobile-menu"
        >
          <div className="flex flex-col gap-4 px-6 py-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-mobile-${link.href.replace("#", "")}`}
                className="mono-label text-neutral-300 transition-colors hover:text-brand"
                onClick={close}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#kontakt"
              className="btn-primary mt-2 w-fit"
              data-testid="navbar-cta-contact-mobile"
              onClick={close}
            >
              Kontakt
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
